<template>
  <div class="animation-ai">
    <svg width="1.5rem" height="1.5rem" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <path
          id="sparkle"
          d="M 0,-1 C 0.3,-0.3 0.3,-0.3 1,0
             C 0.3,0.3 0.3,0.3 0,1
             C -0.3,0.3 -0.3,0.3 -1,0
             C -0.3,-0.3 -0.3,-0.3 0,-1 Z"
        />
      </defs>

      <!-- 왼쪽 위 -->
      <g transform="translate(28, 24)">
        <use href="#sparkle" fill="#ffffff" transform="scale(16)">
          <animateTransform
            attributeName="transform"
            type="scale"
            values="0;16;12.8;16;16"
            dur="3.2s"
            repeatCount="indefinite"
          />
          <animate attributeName="opacity" values="0;1;0.6;1;1" dur="3.2s" repeatCount="indefinite" />
        </use>
      </g>

      <!-- 오른쪽 -->
      <g transform="translate(65, 50)">
        <use href="#sparkle" fill="#ffffff" transform="scale(32)">
          <animateTransform
            attributeName="transform"
            type="scale"
            values="0;32;25.6;32;32"
            dur="3.2s"
            begin="0.3s"
            repeatCount="indefinite"
          />
          <animate attributeName="opacity" values="0;1;0.6;1;1" dur="3.2s" begin="0.3s" repeatCount="indefinite" />
        </use>
      </g>

      <!-- 왼쪽 아래 -->
      <g transform="translate(22, 72)">
        <use href="#sparkle" fill="#ffffff" transform="scale(20)">
          <animateTransform
            attributeName="transform"
            type="scale"
            values="0;20;16;20;20"
            dur="3.2s"
            begin="0.6s"
            repeatCount="indefinite"
          />
          <animate attributeName="opacity" values="0;1;0.6;1;1" dur="3.2s" begin="0.6s" repeatCount="indefinite" />
        </use>
      </g>
    </svg>
  </div>
</template>
